import React, { useEffect } from 'react';
import { Form, Row, Col, Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { CheckboxInput } from '../../Helpers/Inputs';
import { createTheme, ThemeProvider, Button, SvgIcon, FormGroup } from '@mui/material';
import HazardousActivitiesIcon from '../../../icons/hazardousActivities.svg?react';

import "./Adventures.scss";

const adventuresTheme = {
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: 4,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          alignItems: "flex-start",
          marginTop: 0,
          marginRight: 0,
          marginBottom: 0,
          marginLeft: -2,
          paddingRight: 10,
        },
        label: {
          paddingTop: 4,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#c6c6c6",
          marginRight: 8,
          padding: 0,
        },
      },
    },
  },
};

export default function Adventures(props) {

  const formMethods = useForm({
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: props.formState
  });

  const { handleSubmit, trigger } = formMethods;

  const noneOfTheAboveDisabled =
    props.formState.automobileOrMotorcycleRacing ||
    props.formState.ballooning ||
    props.formState.bungeeJumping ||
    props.formState.hangGliding ||
    props.formState.pilotingAnAircraft ||
    props.formState.scubaDiving ||
    props.formState.skyDiving;

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
    trigger(field);
  };

  useEffect(() => {
    if (noneOfTheAboveDisabled && props.formState.none) {
      props.onFieldChange('none', false);
    } else if (!noneOfTheAboveDisabled && !props.formState.none) {
      props.onFieldChange('none', true);
    }
  }, [noneOfTheAboveDisabled]);

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...adventuresTheme,
    })}>
      <Container className="adventure-form personalize-step">
        <FormProvider {...formMethods}>
          <Form onSubmit={handleSubmit(props.onNext)}>
            <Row className="justify-content-center">
              <Col lg={4} className="adventures-container w-100">
                <Row className="justify-content-center pt-2">
                  <div className={`icon-container background-color-16`}>
                    <SvgIcon component={HazardousActivitiesIcon} color="primary" fontSize="large" />
                  </div>
                </Row>
                <Row className="justify-content-center">
                  <p className="mainTitle">Adventures</p>
                </Row>
                <Row className="row-content mx-0">
                  <p className="subTitle">I have participated in the following:</p>
                </Row>
                <Row className="row-content mx-0">
                  <FormGroup className="checkboxes px-0">
                    <CheckboxInput
                      name="automobileOrMotorcycleRacing"
                      id="automobileOrMotorcycleRacing"
                      checked={props.formState.automobileOrMotorcycleRacing}
                      onChange={(e) => handleValueChange('automobileOrMotorcycleRacing', e.target.checked)}
                      label="Automobile or Motorcycle Racing"
                    />
                    <CheckboxInput
                      name="ballooning"
                      id="ballooning"
                      checked={props.formState.ballooning}
                      onChange={(e) => handleValueChange('ballooning', e.target.checked)}
                      label="Ballooning"
                    />
                    <CheckboxInput
                      name="bungeeJumping"
                      id="bungeeJumping"
                      checked={props.formState.bungeeJumping}
                      onChange={(e) => handleValueChange('bungeeJumping', e.target.checked)}
                      label="Bungee Jumping"
                    />
                    <CheckboxInput
                      name="hangGliding"
                      id="hangGliding"
                      checked={props.formState.hangGliding}
                      onChange={(e) => handleValueChange('hangGliding', e.target.checked)}
                      label="Hang Gliding"
                    />
                    <CheckboxInput
                      name="pilotingAnAircraft"
                      id="pilotingAnAircraft"
                      checked={props.formState.pilotingAnAircraft}
                      onChange={(e) => handleValueChange('pilotingAnAircraft', e.target.checked)}
                      label="Piloting an aircraft"
                    />
                    <CheckboxInput
                      name="scubaDiving"
                      id="scubaDiving"
                      checked={props.formState.scubaDiving}
                      onChange={(e) => handleValueChange('scubaDiving', e.target.checked)}
                      label="Scuba Diving"
                    />
                    <CheckboxInput
                      name="skyDiving"
                      id="skyDiving"
                      checked={props.formState.skyDiving}
                      onChange={(e) => handleValueChange('skyDiving', e.target.checked)}
                      label="Sky Diving"
                    />
                    <CheckboxInput
                      name="none"
                      id="none"
                      checked={props.formState.none}
                      disabled={noneOfTheAboveDisabled}
                      label="None of the Above"
                    />
                  </FormGroup>
                </Row>
              </Col>
            </Row>
            <Row className="pre-quote-nav-control">
              <Col className="text-start btn-back">
                <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
                  BACK
                </Button>
              </Col>
              <Col className="text-end">
                <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
                  NEXT
                </Button>
              </Col>
            </Row>

          </Form>
        </FormProvider>
      </Container>
    </ThemeProvider>
  );
}

Adventures.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

Adventures.DefaultFormState = () => {
  return {
    automobileOrMotorcycleRacing: false,
    ballooning: false,
    bungeeJumping: false,
    hangGliding: false,
    pilotingAnAircraft: false,
    scubaDiving: false,
    skyDiving: false,
    none: true,
  };
};
